import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/pages/dashboard.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/fast-search',
      name: 'Fast search',
      component: () => import('@/pages/fast-search.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/login.vue'),
    },
    {
      path: '/update/login',
      name: 'update.login',
      component: () => import('@/pages/update/login.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/delete/duplicates',
      name: 'delete.duplicates',
      component: () => import('@/pages/delete/duplicates.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/delete/rgpd',
      name: 'delete.rgpd',
      component: () => import('@/pages/delete/rgpd.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/update/email',
      name: 'update.email',
      component: () => import('@/pages/update/email.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/update/secret-question',
      name: 'update.secret-question',
      component: () => import('@/pages/update/secret-question.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/update/gender',
      name: 'update.gender',
      component: () => import('@/pages/update/gender.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/update/demat-status',
      name: 'update.demat-status',
      component: () => import('@/pages/update/demat-status.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/update/firstname-lastname',
      name: 'update.firstname-lastname',
      component: () => import('@/pages/update/firstname-lastname.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/unlock/attempts',
      name: 'unlock.attempts',
      component: () => import('@/pages/unlock/attempts.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/logs/edocperso',
      name: 'logs.edocperso',
      component: () => import('@/pages/logs/edocperso.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/logs/edocparaph',
      name: 'logs.edocparaph',
      component: () => import('@/pages/logs/edocparaph.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/logs/webdriver',
      name: 'logs.webdriver',
      component: () => import('@/pages/logs/webdriver.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/logs/transfert_sftp/asterion',
      name: 'logs.transfert_sftp.asterion',
      component: () => import('@/pages/logs/transfert_sftp.vue'),
      props: {
        title: 'Transfert SFTP Asterion - Recherche de log',
        sub_domain: 'asterion',
      },
      meta: {
        auth: true,
      },
    },
    {
      path: '/logs/transfert_sftp/edocperso',
      name: 'logs.transfert_sftp.edocperso',
      component: () => import('@/pages/logs/transfert_sftp.vue'),
      props: {
        title: 'Transfert SFTP eDocPerso - Recherche de log',
        sub_domain: 'edocperso',
      },
      meta: {
        auth: true,
      },
    },
    {
      path: '/logs/notifier_manager_edocperso',
      name: 'logs.notifier_manager_edocperso',
      component: () => import('@/pages/logs/notification_manager.vue'),
      meta: {
        auth: true,
      },
      props: {
        title: 'Notification Manager eDocPerso - Recherche de log',
        host: 'back-edocfactory',
      },
    },
    {
      path: '/logs/notifier_manager_edocsign',
      name: 'logs.notifier_manager_edocsign',
      component: () => import('@/pages/logs/notification_manager.vue'),
      meta: {
        auth: true,
      },
      props: {
        title: 'Notification Manager eDocSign - Recherche de log',
        host: 'back-edocparaph-prod',
      },
    },
    {
      path: '/logs/parapher',
      name: 'logs.parapher',
      component: () => import('@/pages/logs/parapher.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/mails/search',
      name: 'mails.search',
      component: () => import('@/pages/mails/search.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/ip/whitelist',
      name: 'ip.whitelist',
      component: () => import('@/pages/ip/whitelist.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/ip/unlock',
      name: 'ip.unlock',
      component: () => import('@/pages/ip/unlock.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/add/efolia_id',
      name: 'add.efolia_id',
      component: () => import('@/pages/add/efoliaId.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/mails/invalids',
      name: 'mails.invalids',
      component: () => import('@/pages/mails/invalids.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/pages/dashboard.vue'),
      meta: {
        auth: true,
      },
    },
    {
      path: '*',
      name: 'not.found',
      component: () => import('@/pages/not-found.vue'),
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.auth) && !store.state.auth.session.auth) {
    next({ name: 'login' });
  } else {
    next();
  }
});

export default router;
